<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader class="d-flex justify-content-between align-items-center">
          <h5 class="mb-0">AI & AutoAI Interview Plan Details</h5>
          <CButton color="primary" @click="goBack">Back to List</CButton>
        </CCardHeader>

        <CCardBody v-if="plan">
          <!-- General Info -->
          <CCard class="mt-2 shadow-sm">
            <CCardHeader class="bg-info text-white">
              <h6 class="mb-0">General Information</h6>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol md="6">
                  <p><strong>Title:</strong> {{ plan.title }}</p>
                  <p><strong>Type:</strong> {{ plan.type }}</p>
                  <p><strong>Slug:</strong> {{ plan.slug }}</p>
                  <p><strong>Duration:</strong> {{ plan.duration }} ({{ plan.durationValue }} {{ plan.duration }}(s))</p>
                </CCol>
                <CCol md="6">
                  <p><strong>SKU Code (Android):</strong> {{ plan.skuCodeAndroid }}</p>
                  <p><strong>SKU Code (iOS):</strong> {{ plan.skuCodeIos }}</p>
                  <p><strong>Minutes:</strong> {{ plan.minutes }}</p>
                  <p><strong>Status:</strong> <CBadge :color="plan.isActive ? 'success' : 'secondary'">{{ plan.isActive ? 'Active' : 'Inactive' }}</CBadge></p>
                </CCol>
                <CCol md="12" class="mt-2">
                  <p><strong>Description:</strong> {{ plan.description }}</p>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>

          <!-- Platforms -->
          <CCard class="mt-3 shadow-sm" v-if="plan.platforms && plan.platforms.length" v-for="platform in plan.platforms" :key="platform.id">
            <CCardHeader class="bg-warning text-dark">
              <h6 class="mb-0 text-white">Platform: {{ platformLabel(platform.platform) }}</h6>
            </CCardHeader>
            <CCardBody>
              <CRow class="border-bottom pb-2 mb-2">
                <CCol
                  md="6"
                  v-for="price in platform.prices"
                  :key="price.id"
                  class="mb-3"
                >
                  <CCard class="shadow-sm">
                    <CCardBody>
                      <h6 class="text-primary mb-3">{{ price.currency.title }} ({{ price.currency.currencyCode }})</h6>
                      
                      <!-- Pricing Information -->
                      <div class="pricing-section mb-3">
                        <h6 class="text-secondary">Pricing</h6>
                        <p><strong>Price:</strong> {{ price.currency.symbol }}{{ price.price }}</p>
                        <p><strong>Offer Price:</strong> {{ price.currency.symbol }}{{ price.offerPrice }}</p>
                        <p><strong>Total Paid by Member:</strong> {{ price.currency.symbol }}{{ price.totalAmountPaidByMember }}</p>
                        <p><strong>Base Plan Price:</strong> {{ price.currency.symbol }}{{ price.basePlanPrice }}</p>
                      </div>

                      <!-- GST Information -->
                      <div class="gst-section mb-3" v-if="price.hasGst">
                        <h6 class="text-secondary">GST Details</h6>
                        <p><strong>Has GST:</strong> <CBadge color="success">Yes</CBadge></p>
                        <p><strong>GST Business Name:</strong> {{ price.gstBusinessName }}</p>
                        <p><strong>GST Number:</strong> {{ price.gstNumber }}</p>
                        <p><strong>GST on Plan:</strong> {{ price.currency.symbol }}{{ price.gstOnPlan }} ({{ price.gstPercentageOnPlan }}%)</p>
                        <p><strong>GST on Platform:</strong> {{ price.currency.symbol }}{{ price.gstOnPlatform }} ({{ price.gstPercentageOnPlatform }}%)</p>
                        <p><strong>Is Inclusive:</strong> <CBadge :color="price.isInclusive ? 'success' : 'warning'">{{ price.isInclusive ? 'Yes' : 'No' }}</CBadge></p>
                      </div>
                      <div class="gst-section mb-3" v-else>
                        <h6 class="text-secondary">GST Details</h6>
                        <p><strong>Has GST:</strong> <CBadge color="secondary">No</CBadge></p>
                      </div>

                      <!-- Platform Fee Information -->
                      <div class="platform-fee-section">
                        <h6 class="text-secondary">Platform Fee</h6>
                        <p><strong>Platform Fee:</strong> {{ price.currency.symbol }}{{ price.platformFee }} ({{ price.platformFeePercentage }}%)</p>
                        <p><strong>Platform Fee with GST:</strong> {{ price.currency.symbol }}{{ price.platformFeeWithGst }}</p>
                        <p><strong>Amount to Platform:</strong> {{ price.currency.symbol }}{{ price.amountToPlatform }}</p>
                        <p><strong>Amount to Resourceful:</strong> {{ price.currency.symbol }}{{ price.amountToResourceful }}</p>
                      </div>
                    </CCardBody>
                  </CCard>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCardBody>

        <CCardBody v-else>
          <CAlert color="info" show>Loading AI & AutoAI Interview Plan details...</CAlert>
        </CCardBody>

        <CCardFooter>
          <CButton color="primary" @click="goBack">Back to List</CButton>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { aiAutoAIInterviewPlan } from "/src/store/url.js"
import { Mixin } from '/src/mixins/index.js'
import store from '@/store/store'

export default {
  name: 'AiAutoAiInterviewPlanDetails',
  mixins: [Mixin],
  data() {
    return {
      plan: null,
      id: this.$route.params.id,
      module: aiAutoAIInterviewPlan
    }
  },
  mounted() {
    store.commit('showLoader', true)
    this.fetchDetails()
  },
  methods: {
    platformLabel(val) {
      const mapping = { 0: 'Web', 1: 'Android', 2: 'iOS' }
      return mapping[val] || val
    },
    async fetchDetails() {
      try {
        const response = await axios.get(this.viewUrlApi(this.module, this.id))
        this.plan = response.data.data
      } catch (error) {
        console.error('Error:', error)
        this.plan = null
      } finally {
        store.commit('showLoader', false)
      }
    },
    goBack() {
      this.$router.push({ name: 'AI & AutoAI Interview Plan List' })
    },
    formatDate(date) {
      if (!date) return 'N/A'
      return new Date(date).toLocaleDateString('en-IN', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    }
  }
}
</script>

<style scoped>
p {
  margin-bottom: 0.5rem;
}
h6 {
  margin-bottom: 0.5rem;
}
.shadow-sm {
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}
.pricing-section,
.gst-section,
.platform-fee-section {
  border-left: 3px solid #e9ecef;
  padding-left: 10px;
}
.pricing-section {
  border-left-color: #20a8d8;
}
.gst-section {
  border-left-color: #ffc107;
}
.platform-fee-section {
  border-left-color: #4dbd74;
}
</style>